import React from 'react';
import {
  FieldRadioToggle,
  FieldRadioToggleProps,
} from '@spotify-internal/anchor-ds';
import { HookFormProps, FieldController } from 'client/shared/FieldController';

export type ControlledFieldRadioToggleProps = HookFormProps &
  Omit<FieldRadioToggleProps, 'onChange'>;

export const ControlledFieldRadioToggle = (
  props: ControlledFieldRadioToggleProps
) => (
  <FieldController<FieldRadioToggleProps, HTMLInputElement>
    as={FieldRadioToggle}
    {...props}
  />
);
